<template>
  <div
    class="ml-1 flex flex-nowrap items-center gap-x-1 font-medium text-neutral-emphasis hover:text-neutral-primary">
    <UiIcon name="close" size="sm" />
    <button
      data-testid="filter_click_textButton_reset"
      class="text-xs hover:underline"
      @click="handleReset">
      {{ t("savedSearches.resetFilter") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { useI18n } from "vue-i18n";

import { useTracking } from "@/composition/shared/useTracking.ts";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";

const { t } = useI18n();
const { trackEvent } = useTracking();

const filterSelectorStore = useFilterSelectorStore();

function handleReset() {
  filterSelectorStore.resetFilters();
  trackEvent("filter_click_textButton_reset", t("savedSearches.resetFilter"));
}
</script>
